import { createComponent } from '@mtfe/sweet';
import { eventBus } from '@mtfe/sweet-utils';
import { componentUtils } from '@mtfe/sweet-components';

import store from '../../../../store';
import style from './style.less';
import tpl from './dom.html';
import ShangouCouponList from '../../../../components/ShangouCouponList/script';
import InnerPoi from '../../../../components/common/InnerPoi/script';
import SkuCouponListV2 from '../../../../components/SkuCouponListV2/script';
import { renderPoiInfoG } from '../../../../utils/renderPoi';

const { storeCommon } = store;
const { getOnClickEventName } = componentUtils;

const V2Ready = () => {
    eventBus.$onceOn('V2Ready', () => {
        const { dom_sg_every_day_coupon: domSgEveryDayCoupon, dom_sg_cps_unbind_coupon_sku: domSgSkuCoupon } = storeCommon.structInfo.struct;
        const storeSgSkuCoupon = store[domSgSkuCoupon.recallBizId];
        const storeSgEveryDayCoupon = store[domSgEveryDayCoupon.recallBizId];

        // 带下挂菜红包曝光
        if (storeSgSkuCoupon.isShow) {
            eventBus.$emit('SkuCouponListV2Ready');
        }
        // 每日优惠券曝光
        if (storeSgEveryDayCoupon.isShow) {
            eventBus.$emit('ShangouCouponListReady');
            eventBus.$emit(getOnClickEventName(domSgEveryDayCoupon.recallBizId));
        }
    });
};

const V2 = () => {
    try {
        const { dom_sg_every_day_coupon: domSgEveryDayCoupon, dom_sg_cps_unbind_coupon_sku: domSgSkuCoupon } = storeCommon.structInfo.struct;

        const storeSgSkuCoupon = store[domSgSkuCoupon.recallBizId];
        const storeSgEveryDayCoupon = store[domSgEveryDayCoupon.recallBizId];

        let redBagWelfareTitle = '福利1';
        let everyDayCouponWelfareTitle = '福利2';

        if (!storeSgSkuCoupon.isShow || !storeSgEveryDayCoupon.isShow) {
            redBagWelfareTitle = '福利';
            everyDayCouponWelfareTitle = '福利';
        }

        const data = {
            skuCouponListDom: storeSgSkuCoupon.isShow
                ? SkuCouponListV2({
                      welfareIndex: redBagWelfareTitle,
                      targetStore: storeSgSkuCoupon,
                      couponKey: 'Shangou',
                  })
                : '',
            sgEveryDayDom: storeSgEveryDayCoupon.isShow
                ? ShangouCouponList({
                      couponListInfo: storeSgEveryDayCoupon.discountData,
                      welfareIndex: everyDayCouponWelfareTitle,
                  })
                : '',
            poiList: storeSgEveryDayCoupon.isShow
                ? InnerPoi({
                      poiData: storeSgEveryDayCoupon.poiData,
                      isOpenAutoLoading: false,
                      renderFunc: renderPoiInfoG,
                  })
                : '',
        };
        const events = {};
        V2Ready();
        return createComponent(tpl, { style, data }, events);
    } catch (error) {
        console.error(error);
        return '';
    }
};

export default V2;
